import { FaCheck } from "react-icons/fa"
import { GiHamburgerMenu } from "react-icons/gi";
import { IoCloseSharp } from "react-icons/io5";

export const MenuIcon = GiHamburgerMenu
export const MenuCloseIcon = IoCloseSharp
export const TickIcon = FaCheck